var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPowerOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "regular/power-off",
    clipPath: "url(#clip0_278_5306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.1406 1.44687C14.3094 2.82188 15.75 5.24375 15.75 8C15.75 12.275 12.2875 15.7406 8.01563 15.75C3.75001 15.7594 0.256255 12.2812 0.250005 8.0125C0.24688 5.25 1.6875 2.82188 3.85938 1.44687C4.04063 1.33125 4.28125 1.39062 4.3875 1.57812L4.75625 2.23125C4.85313 2.40313 4.8 2.62188 4.63438 2.72813C2.90001 3.84063 1.75001 5.78438 1.75001 8C1.75001 11.4531 4.54688 14.25 8 14.25C11.4531 14.25 14.25 11.4531 14.25 8C14.25 5.78438 13.1 3.84063 11.3656 2.73125C11.2 2.625 11.1469 2.40625 11.2438 2.23438L11.6125 1.58125C11.7156 1.39062 11.9594 1.33438 12.1406 1.44687ZM8.75 8.625V0.375C8.75 0.16875 8.58125 0 8.375 0H7.625C7.41876 0 7.25 0.16875 7.25 0.375V8.625C7.25 8.83125 7.41876 9 7.625 9H8.375C8.58125 9 8.75 8.83125 8.75 8.625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_278_5306"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerOff);
export default __webpack_public_path__ + "static/media/power-off.e4e7e532204675790bfa77f7aaae7ff6.svg";
export { ForwardRef as ReactComponent };